import { createContext } from 'react';

const AppRoutesHistoryContext = createContext<Readonly<string[]>>([]);

export default AppRoutesHistoryContext;
